import { render, staticRenderFns } from "./BusquedaTramites.vue?vue&type=template&id=285a20f7&scoped=true"
import script from "./BusquedaTramites.vue?vue&type=script&lang=ts"
export * from "./BusquedaTramites.vue?vue&type=script&lang=ts"
import style0 from "./BusquedaTramites.vue?vue&type=style&index=0&id=285a20f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285a20f7",
  null
  
)

export default component.exports